if (!window.fbControls) window.fbControls = [];
window.fbControls.push(function (controlClass) {
	class controlYesNoGroupHolder extends controlClass {
		static get definition() {
			return {
				icon: '<i class="fa fa-gavel" aria-hidden="true"></i>',
				i18n: {
					default: 'Yes/No Group'
				}
			};
		}
		configure() { }
		build() {
			let fieldContainerAttributes = this.config.fieldContainerAttributes || '';
			let className = this.config.className || '';
			let id = this.config.id;
			let yesLabel = this.config.yesLabel || 'Yes';
			let noLabel = this.config.noLabel || 'No';
			let template = 
				`<div ${(fieldContainerAttributes) ? fieldContainerAttributes : '' } class="${className}">` +
					'<div class="text-button text-button-yes">'+
						`<button
							type="submit"
							name="${id}_button-yes"
							class="btn btn-success"
							onclick="document.getElementById('${this.config.name}_yesnovalue').value = 'yes';"
							value="yes">`+
							yesLabel +
						'</button>' +
					'</div>' +
					'<div class="text-button text-button-no">'+
						`<button
							type="submit"
							name="${id}_button-no"
							class="btn btn-danger"
							onclick="document.getElementById('${this.config.name}_yesnovalue').value = 'no';"
							value="no">`+
							noLabel +
						'</button>' +
					'</div>' +
				'</div>'
			return template;
		}
		onRender() {
		}
	}
	controlClass.register('yesnogroup', controlYesNoGroupHolder);
	return controlYesNoGroupHolder;
});
